import bulkImportToast from './bulkImportToast';

const event = (payload, subjectId = 7) => ({ id: 1, subjectId, payload });

describe('management/Users bulkImportToast', () => {
  it('celebrates a clean import', () => {
    const toast = bulkImportToast(
      event({ status: 'success', succeeded: 90, total: 90 }),
    );

    expect(toast.intent).toEqual('success');
    expect(toast.title).toEqual('Users Successfully Created.');
    expect(toast.body).toEqual('90 Users created to selected Accounts.');
  });

  it('reports both numbers for a partial import', () => {
    const toast = bulkImportToast(
      event({ status: 'partial_success', succeeded: 98, failed: 4 }),
    );

    expect(toast.intent).toEqual('warning');
    expect(toast.title).toEqual('Users Partially Created.');
    expect(toast.body).toEqual(
      '98 Users successfully created, 4 Failed to be created to the selected Accounts.',
    );
  });

  it('keeps the failure toast generic, as the design does', () => {
    const toast = bulkImportToast(event({ status: 'failure', failed: 12 }));

    // KeyDS Notification names this intent "danger"; the mockup draws it red.
    expect(toast.intent).toEqual('danger');
    expect(toast.title).toEqual('Users Upload Failed.');
    expect(toast.body).toEqual(
      'Try again, or contact support if the issue persists.',
    );
  });

  // The report is how the admin finds out which rows failed and what each
  // created user was named, so every outcome offers it.
  it('points at the report for the import it names', () => {
    const toast = bulkImportToast(event({ status: 'success', succeeded: 1 }));

    expect(toast.reportPath).toEqual(
      '/management/bulk_user_imports/7/download.csv',
    );
  });

  it('offers no report when there is no import to point at', () => {
    const toast = bulkImportToast(event({ status: 'success' }, null));

    expect(toast.reportPath).toBeNull();
  });

  // An unknown kind should be ignored rather than raising a blank toast.
  it('produces nothing for a status it does not know', () => {
    expect(bulkImportToast(event({ status: 'processing' }))).toBeNull();
    expect(bulkImportToast({ id: 1 })).toBeNull();
  });
});
